import { render } from "./BoardChosenInitiatives.vue?vue&type=template&id=7470a0d7&scoped=true"
import script from "./BoardChosenInitiatives.vue?vue&type=script&lang=js"
export * from "./BoardChosenInitiatives.vue?vue&type=script&lang=js"

import "./BoardChosenInitiatives.vue?vue&type=style&index=0&id=7470a0d7&scoped=true&lang=css"
import "./BoardChosenInitiatives.vue?vue&type=style&index=1&id=7470a0d7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7470a0d7"]])

export default __exports__